<template>
	<div class="space-layer">
		<light-header></light-header>
		<div class="space-content auto">
			<div class="menu-content auto">
				<div class="menu">
					<div class="magic-btn-wrap">
						<el-button class="magic-btn" @click="handleLaunchTask">
							<img src="@/assets/images/space/launch-btn-in.png" alt="" class="btn-in-img">发起签署
						</el-button>
					</div>

					<el-menu :default-active="onRoutes" router class="el-menu-vertical" @open="handleOpen"
						@close="handleClose" @select="handleSelect" :unique-opened="false"
						:default-openeds="['/space', '/approve']">
						<el-submenu index="/space">
							<template slot="title">
								<span class="first-menu">合同管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/space/contract-list?status=all">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-all" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-all-active" class="menu-icon active"></svg-icon>
										</div><span class="menu-text">全部</span>
										<span class="menu-num">{{
											userContractInfoAall
										}}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=waitSend">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-waitsend" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-waitsend-active" class="menu-icon active"></svg-icon>
										</div><span class="menu-text">待发送</span>
										<span class="menu-num">{{
											userContractInfo.waitSend
										}}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=iSign">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-isign" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-isign-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">待我签署</span>
										<span class="menu-num">{{ userContractInfo.iSign }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=otherSign">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-othersign" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-othersign-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">待他签署</span>
										<span class="menu-num">{{
											userContractInfo.otherSign
										}}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=process"
									v-if="userScope.spaceType === 'company'">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-process" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-process-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">审批中</span>
										<span class="menu-num">{{ userContractInfo.process }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=finish">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-finish" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-finish-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">签署完成</span>
										<span class="menu-num">{{ userContractInfo.finish }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=reject">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-reject" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-reject-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">拒签</span>
										<span class="menu-num">{{ userContractInfo.reject }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=recall">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-recall" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-recall-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">已撤回</span>
										<span class="menu-num">{{ userContractInfo.recall }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=expire">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-expire" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-expire-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">已过期</span>
										<span class="menu-num">{{ userContractInfo.expire }}</span>
									</template>
								</el-menu-item>


								<!-- <el-menu-item index="/user-space/contract-list?status=returnd">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/return2-icon.png" alt="">
                    <img width="15" class="img2" src="../../assets/images/index/return1-icon.png" alt="">
                    <span class="menu-text">被退回</span>
                    <span class="menu-num">{{userContractInfo.returnd}}</span>
                  </template>
                </el-menu-item> -->
								<el-menu-item index="/space/contract-list?status=cancel">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-cancel" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-cancel-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">已作废</span>
										<span class="menu-num">{{ userContractInfo.cancel }}</span>
									</template>
								</el-menu-item>
								<el-menu-item index="/space/contract-list?status=draft">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-draft" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-draft-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">草稿箱</span>
										<span class="menu-num">{{ userContractInfo.draft }}</span>
									</template>
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="/approve"
							v-if="$store.state.userInfo.userType == 'person' && $store.state.currentSpace.space.spaceType == 'company'">
							<template slot="title">
								<span class="first-menu">审批管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="/approve/list?status=mylauch">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-my-launch" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-my-launch-active" class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">我发起的</span>
										<span class="menu-num">{{ userContractInfo.mylauch }}</span>
									</template>
								</el-menu-item>
							</el-menu-item-group>
							<el-menu-item-group>
								<el-menu-item index="/approve/list?status=myapproval">
									<template>
										<div class="flex-center">
											<svg-icon iconClass="menu-my-approval" class="menu-icon"></svg-icon>
											<svg-icon iconClass="menu-my-approval-active"
												class="menu-icon active"></svg-icon>
										</div>
										<span class="menu-text">我审批的</span>
										<span class="menu-num">{{ userContractInfo.myapproval }}</span>
									</template>
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<!-- <el-menu-item index="/space/signatures" class="parent"
							v-if="userInfo.userType === 'company' || (userInfo.userType === 'person' && userScope.spaceType === 'person')">
							<span class="first-menu" slot="title">签章管理</span>
						</el-menu-item> -->
						<!-- <el-menu-item index="3" class="parent">
              <span class="first-menu" slot="title">费用管理</span>
            </el-menu-item> -->
					</el-menu>
				</div>

				<div class="space-list">
					<router-view :space="userScope.spaceType"></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import lightHeader from "@/components/lightHeader";
import { getUserInfoApi } from "@/api/home";
import { contractCountApi } from "@/api/space/contracts";
import { getSpaceDetailInfo } from "@/api/home";
import { mapState } from "vuex";
export default {
	components: {
		lightHeader,
	},
	data() {
		return {
			userScope: { spaceType: 'company' },
			authIcons: [
				require("../../assets/images/authed.png"),
				require("../../assets/images/not-auth.png"),
			],
			authUserHeaderImgs: [
				require("../../assets/images/index/user1-icon.png"),
				require("../../assets/images/index/user2-icon.png"),
			]
		};
	},
	computed: {
		onRoutes() {
			let path;
			if (this.$route.query.status) {
				path = this.$route.path + "?status=" + this.$route.query.status;
			} else {
				path = this.$route.path;
			}
			return path;
		},
		idCard() {
			var str1 = "";
			if (this.userInfo.idCard) {
				str1 = this.userInfo.idCard.replace(
					/(\d{1})(\d+)(\d{1})/,
					function (x, y, z, p) {
						var i = "";
						while (i.length < z.length) {
							i += "*";
						}
						return y + i + p;
					}
				);

				return str1;
			}
		},
		phone() {
			var str1 = "";
			if (this.userInfo.phone) {
				str1 = this.userInfo.phone.replace(
					/(\d{3})(\d+)(\d{4})/,
					function (x, y, z, p) {
						var i = "";
						while (i.length < z.length) {
							i += "*";
						}
						return y + i + p;
					}
				);

				return str1;
			}
		},
		userContractInfoAall() {
			let sum = 0;
			Object.keys(this.userContractInfo).map((_key => {
				if (_key !== 'myapproval' && _key !== 'mylauch') {
					sum += Number(this.userContractInfo[_key]);
				}

			}))
			return sum;
		},
		...mapState(["userInfo", "userContractInfo"]),
	},
	mounted() {
		this.handleGetSpaceDetailInfo();
		this.getContractCount();
		this.$bus.$on("emitSpaceChange", (data) => {
			this.handleGetSpaceDetailInfo();
			this.getContractCount();
		});
	},
	beforeDestroy() {
		//销毁监听事件
		this.$bus.$off("emitSpaceChange");
	},
	methods: {
		handleLaunchTask() {
			if (this.userScope.isAuthed == 'passAuth') {
				this.$router.push({
					path: "/temp-create",
					query: {
						from: this.$route.fullPath.replace(/\?/, "!!"),
					},
				});
			}
		},
		handleCart() {
			this.$router.push({
				path: "/cart/cart",
			});
		},
		handleGetSpaceDetailInfo() {
			getSpaceDetailInfo().then((res) => {
				if (res.code === 200) {
					this.userScope = res.data;
				}
			});
		},
		getContractCount() {
			contractCountApi()
				.then((res) => {
					if (res.code !== 200) {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning",
						});
					} else {
						this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		handleOpen(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleSelect(key, keyPath) {
			// this.getUserInfoHandle()
		},
		toFlow() {
			this.$router.push({
				path: "/temp-create",
				query: {
					from: this.$route.fullPath.replace(/\?/, "!!"),
				},
			});
		},
		toConsole() {
			const consoleHref = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL);
			return consoleHref;
		},
	},
};
</script>


<style lang="scss" scoped>
.space-layer {
	background: #F3F3F7;
	min-height: calc(100vh);
}

.space-content {
	margin-top: 20px;

	height: calc(100vh - 100px);

	.menu-content {
		display: flex;
		justify-content: space-between;
		height: 100%;

		.menu {
			width: 160px;
			// min-height: 818px;
			background: #fff;
			border-radius: 10px;
			overflow-y: auto;

			.magic-btn-wrap {
				padding: 24px 16px;
				position: relative;
				height: 84px;
			}

			.magic-btn {
				width: 128px;
				height: 42px;
				background: #3F7BF9 linear-gradient(90deg, #5890FF 0%, #256BFF 100%);
				border-radius: 6px 6px 6px 6px;
				font-size: 14px;
				font-weight: 500;
				color: #FFFFFF;
				padding: 0;
				position: absolute;
				border: none;
				z-index: 2;

				&:not(.is-disabled):active {
					outline: 3px solid rgba(22, 93, 255, 0.15);
				}

				&.is-disabled {
					opacity: .5;
				}

				&:not(.is-disabled):hover {
					&::after {
						opacity: 0;
						content: "";
						background: #fff;
					}

					transform: translateY(4px);
					transition: transform ease .3s;
				}

				&::after {
					display: block;
					content: "";
					opacity: 1;
					width: 128px;
					height: 42px;
					background: #3F7BF9 linear-gradient(90deg, #5890FF 0%, #256BFF 100%);
					border-radius: 4px 4px 4px 4px;
					opacity: 0.2;
					border: 1px solid #5999FF;
					filter: blur(12px);
					position: absolute;
					top: 10px;
					left: 0;
					z-index: -9;
				}



				/deep/ span {
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.btn-in-img {
					width: 30px;
					height: 30px;
					margin-right: 3px;
					margin-top: 3px;
				}
			}

			.el-menu-vertical {
				/deep/ .el-submenu__title {
					height: 60px;
					line-height: 60px;
					font-size: 16px;
					font-weight: 500;
					color: #1D2129;
					padding: 0 24px !important;
					background: none;
				}

				/deep/ .el-submenu__icon-arrow {
					font-size: 16px;
					font-weight: bold;
					color: #1D2129;
					padding: 1px;
				}

				/deep/ .el-menu-item {
					height: 40px;
					line-height: 40px;
					margin: 4px 0;
					padding-left: 24px !important;
					padding-right: 0;
					margin-right: 10px;
					min-width: unset;
					border-radius: 0px 10px 10px 0px;

					font-size: 14px;
					font-weight: 500;
					color: #4E5969;

					display: flex;
					align-items: center;
					justify-content: flex-start;

					&.is-active {
						background: #F0F5FF;
						color: #165DFF;

						.menu-icon {
							display: none;

							&.active {
								display: block;
							}
						}
					}

					&:hover {
						background: #F0F5FF;
					}
				}

				.menu-icon {
					width: 18px;
					height: 18px;
					margin-right: 14px;

					&.active {
						display: none;
					}
				}

				.menu-num {
					margin-left: 6px
				}

			}
		}

		.space-list {
			width: calc(100% - 168px);
			min-height: calc(100vh - 287px);
			background: #fff;
			border-radius: 10px;
			overflow: hidden;
		}

	}
}






.space-info {
	width: 100%;
	height: 164px;
	background: rgba(255, 255, 255, 1);
	padding: 28px 79px 28px 29px;
	// box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
	display: flex;
	justify-content: space-between;
	align-items: center;

	.left {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;

		.left-top {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 18px;

			.user-img {
				width: 51px;
				height: 51px;
				margin-right: 16px;
			}

			.user-name {
				margin-right: 12px;
			}

			.user-auth {
				width: 48px;
				height: auto;
				margin-top: 2px;
			}
		}

		.left-bottom {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 16px;
			padding-left: 67px;
			padding-bottom: 15px;
			color: #999999;

			&>div {
				margin-right: 22px;
			}

			.value {
				font-weight: bold;
				color: #333333;
				margin-left: 15px;
			}
		}

		.person-left-bottom {
			font-size: 16px;
			color: #999999;
			padding-left: 67px;

			&>div {
				margin-right: 22px;
				margin-top: 10px;
			}

			.value {
				font-weight: bold;
				color: #333333;
				margin-left: 15px;
			}
		}
	}

	.mid {
		height: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		padding-bottom: 15px;

		.mid-item {
			text-align: center;
			font-size: 14px;
			font-weight: 400;
			color: #999999;

			.count {
				font-weight: bold;
				color: #333333;
				font-size: 21px;
				margin-bottom: 14px;
			}
		}

		.mid-item+.mid-item {
			margin-left: 67px;
		}
	}

	.right {
		height: 80%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		.to-sign {
			width: 100px;
			height: 32px;
			background: linear-gradient(0deg,
					rgba(59, 178, 253, 1) 0%,
					rgba(15, 217, 242, 1) 99%);
			// box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.17);
			border-radius: 10px;
			text-align: center;
			display: block;
			line-height: 32px;
			color: #ffffff;
			font-size: 14px;
		}

		.to-console {
			margin-top: 30px;
			width: 100px;
			height: 32px;
			background: #ff6633;
			// box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.17);
			border-radius: 8px;
			color: #fff;
			text-align: center;
			border-radius: 10px;
			display: block;
			line-height: 32px;
			font-size: 14px;
		}
	}
}

.user-space-info .card {
	position: absolute;
	left: 99px;
	top: 78px;
	width: 700px;
}

.user-space-info .phone {
	position: absolute;
	left: 99px;
	top: 117px;
	width: 700px;
}

.user-space-info .card,
.user-space-info .phone {
	font-size: 16px;
	line-height: 16px;
}

.user-space-info .card span:nth-of-type(1),
.user-space-info .phone span:nth-of-type(1) {
	color: #999999;
	width: 65px;
	float: left;
}

.user-space-info .card span:nth-of-type(2),
.user-space-info .phone span:nth-of-type(2) {
	color: #333333;
	margin-left: 25px;
}

.company-meal {
	position: absolute;
	left: 528px;
	top: 64px;
	width: 100px;
	text-align: center;
}

.company-meal p:first-child,
.user-meal p:first-child {
	font-size: 26px;
	color: #333333;
	font-weight: 600;
}

.company-meal p:last-child,
.user-meal p:last-child {
	font-size: 16px;
	color: #999999;
}

.user-meal {
	position: absolute;
	left: 691px;
	top: 64px;
	text-align: center;
	width: 160px;
}

.user-menu-content {
	/* width: 1200px;
																																											    margin: 22px auto 0; */
	margin-top: 22px;
	display: flex;
	justify-content: space-between;
}

.user-menu {
	width: 230px;
	min-height: calc(100vh - 287px);
	background: rgba(255, 255, 255, 1);
	// box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
}



.first-menu {
	font-size: 16px;
}

.img1 {
	display: none;
	margin-left: -5px;
}

// .el-menu-item:hover,
// .el-menu-item:focus {
// 	background: #ffffff;
// }

// .el-menu-item:hover .menu-text,
// .el-menu-item:focus .menu-text {
// 	color: #333333;
// }

// .el-menu-item:focus .menu-num,
// .el-menu-item:hover .menu-num {
// 	color: #276ee8;
// }

.el-menu-item:hover .img1,
.el-menu-item:focus .img1,
.el-menu-item:active .img1,
.el-menu-item:visited .img1 {
	display: inline-block;
}

.el-menu-item:hover .img2,
.el-menu-item:focus .img2,
.el-menu-item:active .img2,
.el-menu-item:visited .img2 {
	display: none;
}

// /deep/ .el-submenu__title:hover {
// 	background: unset;
// }

// .is-active .el-menu-item {
// 	background: #ffffff;
// 	border: none;
// }

// .is-active .is-active .menu-text {
// 	color: #333333;
// }

.is-active .is-active .img1 {
	display: inline-block;
}

.is-active .is-active .img2 {
	display: none;
}

.el-menu-item.is-active {
	color: #3296fa;
	background-color: #ebf5ffaa;
}

.el-submenu .el-menu-item {
	// margin: 10px 15px;
	height: 45px;
	line-height: 45px;
}

/deep/ .el-menu-item-group__title {
	display: none;
}
</style>
